import React, { useState } from 'react';
import { Form, Input, Button, Typography, Card, notification } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import axios from 'axios';
import Password from 'antd/lib/input/Password';
import { get } from 'lodash';
import { useNavigate } from 'react-router-dom';
import baseUrl from '../../api/baseUrl';
import { brandName, brandTagline } from '../../theme/tokens';

const { Title, Text } = Typography;

const LoginForm: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values: any) => {
        setLoading(true);
        try {
            const data = await axios.post(baseUrl + "api/auth/signin", {
                email: get(values, "email", ""),
                password: get(values, "password", "")
            });
            const tmpData = get(data, "data", "");
            const token = tmpData.split("?role=")[0];
            const role = tmpData.split("?role=")[1];
            // ~10 nam, khop voi drug.app.jwtExpirationMs ben backend - dang nhap gan nhu vinh vien
            localStorage.setItem("access_token", JSON.stringify({value: token, role: role, expiry: new Date().getTime() + 315360000000}));
            navigate("/");
        } catch (error) {
            notification.error({
                message: error.response.data
            })
        }

        setLoading(false);
    };

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                background: 'linear-gradient(160deg, #FDEEF2 0%, #FFF7F9 45%, #F7E3E9 100%)',
                padding: 16,
            }}
        >
            <Card
                style={{
                    width: 380,
                    maxWidth: '100%',
                    borderRadius: 20,
                    border: '1px solid #F0DDE3',
                    boxShadow: '0 20px 45px rgba(214,112,141,0.15)',
                }}
                bodyStyle={{ padding: '36px 32px' }}
            >
                <div style={{ textAlign: 'center', marginBottom: 28 }}>
                    <div
                        style={{
                            width: 56,
                            height: 56,
                            margin: '0 auto 14px',
                            borderRadius: '50%',
                            background: '#F7E3E9',
                            color: '#D6708D',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: 26,
                            fontWeight: 700,
                        }}
                    >
                        H
                    </div>
                    <Title level={3} style={{ marginBottom: 4, color: '#3A2430' }}>{brandName}</Title>
                    <Text style={{ color: '#5B4A52' }}>{brandTagline}</Text>
                </div>
                <Form
                    name="normal_login"
                    className="login-form"
                    layout="vertical"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                >
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[{ required: true, message: 'Chưa nhập email' }]}
                    >
                        <Input size="large" prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Email" />
                    </Form.Item>
                    <Form.Item
                        label="Mật khẩu"
                        name="password"
                        rules={[{ required: true, message: 'Chưa nhập mật khẩu' }]}
                    >
                        <Input
                            size="large"
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            type="password"
                            placeholder="Mật khẩu"
                        />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button type="primary" size="large" htmlType="submit" className="login-form-button" loading={loading} block>
                            Đăng nhập
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default LoginForm;